export default "__VITE_ASSET__D4PObaLE__"